export const formatMass = (massKg) => {
  if (massKg == null || massKg <= 0) return null;

  if (massKg >= 1000) {
    return `${(massKg / 1000).toFixed(2)} t`;
  }
  return `${Math.round(massKg)} kg`;
};
